module.exports = __webpack_public_path__ + "static/media/tutorial0.7697ca31.gif";